'use client';

import { LogoNavigationBar } from '@/components';
import { useDeviceSize } from '@/hooks/useDeviceSize';
import SalesMobileNaviation from './SalesMobileNaviation';

interface SalePageNavigationBarProps {
  salePageId: number;
  type: 'salePage' | 'gachaPage';
}

export const SalePageNavigationBar = ({
  salePageId,
  type,
}: SalePageNavigationBarProps) => {
  const deviceSize = useDeviceSize();

  if (!deviceSize) return null;

  // 배경 색상
  const backgroundColor = type === 'gachaPage' ? 'black' : 'primary';
  // 아이콘 색상
  const iconColor = type === 'gachaPage' ? 'whitePrimary' : 'primary';

  return (
    <>
      {deviceSize === 'mobile' ? (
        <SalesMobileNaviation type={type} salePageId={salePageId} />
      ) : (
        <LogoNavigationBar
          iconColor={iconColor}
          backgroundColor={backgroundColor}
          isShowChannelSelector={false}
        />
      )}
    </>
  );
};
